import { Component, Input, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { observeProperty } from '@lcms/shared/data-access-user';
import { map, tap } from 'rxjs';

@Component({
  selector: 'lcms-documents-result',
  templateUrl: './documents-result.component.html',
  styleUrls: ['./documents-result.component.scss'],
})
export class DocumentsResultComponent {
  @Input() cmpData:any;
  @Input() showDetails?:boolean;
  sanitizer=inject(DomSanitizer);
  data$ = observeProperty(this as DocumentsResultComponent,'cmpData').pipe(
    map(res=>res.map((document:any)=>({...document?._source.metadata,highlights:document?.highlight ?? []}))),
    tap((docs)=>(console.log('docs ',docs)))  
  )
  
  getKeys(obj:any){
    return Object.keys(obj);
  }

  sanitize(term:string){
    return this.sanitizer.bypassSecurityTrustHtml(term);
  }
}
